module.exports = __webpack_public_path__ + "img/icon4.70e69d63.png";